module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedBlackItalic.69eb3c7.woff";